import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  listsrc = '/assets/list_inactive.png' ;
  storagesrc = '/assets/storage_inactive.png' ;
  mapsrc = '/assets/map_inactive.png' ;
  userssrc = '/assets/users_inactive.png' ;
  reports = '/assets/export_inactive.png' ;
  tagssrc = '/assets/tag_inactive.png' ;
  activeTab = '';
  listActive = false;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.navigate('login');
  }

  listMouseEnter(D: string): void {
    switch (D) {
      case 'list':
        this.listsrc = '/assets/list_active.png' ;
        break;

      case 'storage':
          this.storagesrc = '/assets/storage_active.png' ;
          break;

      case 'maps':
        this.mapsrc = '/assets/map_active.png' ;
        break;

      case 'users':
        this.userssrc = '/assets/users_active.png' ;
        break;

      case 'reports':
        this.reports = '/assets/export_active.png' ;
        break;

      case 'tag':
        this.tagssrc = '/assets/tag_active.png' ;
        break;
    }
  }

  listMouseLeave(D: string): void {
    switch (D) {
      case 'list':
        if (this.activeTab !== 'itemsList') { this.listsrc = '/assets/list_inactive.png' ; }
        break;

      case 'storage':
        if (this.activeTab !== 'warehouses') { this.storagesrc = '/assets/storage_inactive.png' ; }
        break;

      case 'maps':
        if (this.activeTab !== 'maps') { this.mapsrc = '/assets/map_inactive.png' ; }
        break;

      case 'users':
        if (this.activeTab !== 'users') { this.userssrc = '/assets/users_inactive.png' ; }
        break;

      case 'reports':
        if (this.activeTab !== 'reports') { this.reports = '/assets/export_inactive.png' ; }
        break;

      case 'tag':
        if (this.activeTab !== 'tag') { this.tagssrc = '/assets/tag_inactive.png' ; }
        break;
    }
  }

  public navigate(S: string): void {
    this.activeTab = S ;
    if (this.activeTab !== 'itemsList') { this.listsrc = '/assets/list_inactive.png' ; }
    if (this.activeTab !== 'warehouses') { this.storagesrc = '/assets/storage_inactive.png' ; }
    if (this.activeTab !== 'maps') { this.mapsrc = '/assets/map_inactive.png' ; }
    if (this.activeTab !== 'users') { this.userssrc = '/assets/users_inactive.png' ; }
    if (this.activeTab !== 'reports') { this.reports = '/assets/export_inactive.png' ; }
    if (this.activeTab !== 'tag') { this.tagssrc = '/assets/tag_inactive.png' ; }
    this.router.navigateByUrl('/' + S);
  }

}
